import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Placeholder from '../../../static/images/placeholder.svg';

type DefaultCardProps = {
    image?: string;
    imageAltText?: string;
    promoType: string;
    title?: string;
    type?: string;
    url?: string;
};

const DefaultCard = ({ image, imageAltText, promoType, title, type, url }: DefaultCardProps) => {
    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={style.imageContainer}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <a href={url}>
                    <h3 className={`${style.title} ${style.twoLineClamp}`}>{unescape(title)}</h3>

                    <div className={style.role}>{type}</div>
                </a>
            </div>
        </div>
    );
};

export default DefaultCard;
